export default __webpack_public_path__ + "static/media/profile-fallback-icon.6f1bf2c8.svg";